import { useTranslation } from 'react-i18next'
import { ServiceCard } from '../ServiceCard'
import { File, FileStack } from 'lucide-preact'
import { getConfig } from '../../../config'
import { Text } from '@/components'

interface ServicesContentProps {
  showTitle?: boolean
  titleClassName?: string
  containerClassName?: string
  serviceCardContainerClassName?: string
}

export function ServicesContent({
  showTitle = true,
  titleClassName = '',
  containerClassName = '',
  serviceCardContainerClassName = '',
}: ServicesContentProps) {
  const { t } = useTranslation()
  const config = getConfig()

  return (
    <div className={containerClassName}>
      {showTitle && (
        <div className='mb-6 mt-4'>
          <h3
            className={`text-heading-4 text-cencert-header-blue mb-0.5 font-montserrat ${titleClassName}`}
          >
            {t('sidebar.moreSignatures.title')}
          </h3>
          <Text variant='small' color='text-gray'>
            {t('sidebar.moreSignatures.subtitle')}
          </Text>
        </div>
      )}

      <div className='space-y-4'>
        {!showTitle && (
          <Text variant='small' color='text-gray' className='mb-4'>
            {t('sidebar.moreSignatures.subtitle')}
          </Text>
        )}

        <div className='space-y-4'>
          <ServiceCard
            title={t('terms.services.commercial.title')}
            description={t('terms.services.commercial.description')}
            linkText={t('terms.services.commercial.link')}
            icon={<File className='text-cencert-blue' />}
            containerClassName={serviceCardContainerClassName}
            onClick={() => {
              window.open(config.commercialSignaturesUrl, '_blank')
            }}
          />

          <ServiceCard
            title={t('terms.services.longterm.title')}
            description={t('terms.services.longterm.description')}
            linkText={t('terms.services.longterm.link')}
            icon={<FileStack className='text-cencert-blue' />}
            containerClassName={serviceCardContainerClassName}
            onClick={() => {
              window.open(config.longtermPlansUrl, '_blank')
            }}
          />
        </div>

        <div className='mt-4'>
          <Text variant='small' color='text-gray'>
            {t('sidebar.purchaseInfo')}
          </Text>
        </div>
      </div>
    </div>
  )
}
